import { render, staticRenderFns } from "./deleteModal.vue?vue&type=template&id=013afabb&scoped=true"
import script from "./deleteModal.vue?vue&type=script&lang=js"
export * from "./deleteModal.vue?vue&type=script&lang=js"
import style0 from "./deleteModal.vue?vue&type=style&index=0&id=013afabb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013afabb",
  null
  
)

export default component.exports